import React from 'react';

import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui/box';
import { layout, primitive, spacing } from 'styles/constants';

export const ButtonText = withTypography({
  color: primitive.$mayoEggWhite,
  textAlign: 'center',
  fontFamily: 'heading',
});

export const SubHeading = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.subHeading, style],
  });

export const Section = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.section, style],
  });

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.container, style],
  });

const styles = StyleSheet.create({
  container: {
    width: layout.full,
  },
  section: {
    marginVertical: spacing.$3,
  },
  subHeading: {
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: spacing.$4,
  },
});
